import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";
import { IPropertyChangeLog } from "./types";

type Props = {
  refImageGroups: IPropertyChangeLog["refImageGroups"];
};

const GroupImageViewer = ({ refImageGroups }: Props) => {
  if (refImageGroups?.length === 0) {
    return null;
  }
  return (
    <div>
      {refImageGroups?.map((refImgGrp) => {
        return (
          <Flex key={refImgGrp.title} direction="column" gap={"8px"}>
            <Typography color="dark.black" fontWeight="medium" size={"title"}>
              {refImgGrp.title}
            </Typography>
            {refImgGrp?.refImages?.map((refImg) => {
              return (
                <Flex direction="column" gap={"4px"}>
                  <Flex>
                    <Typography fontWeight="bold">Title:</Typography>
                    <Typography
                      color="dark.black"
                      fontWeight="medium"
                      size={"title"}
                    >
                      {refImg?.title}
                    </Typography>
                  </Flex>
                  <Flex>
                    <Typography fontWeight="bold">Description:</Typography>
                    <Typography>{refImg?.description}</Typography>
                  </Flex>
                  <Flex>
                    <Typography fontWeight="bold">Visibility:</Typography>
                    <Typography>
                      {refImg?.isVisible ? "Visible" : "Hidden"}
                    </Typography>
                  </Flex>
                  <Flex>
                    <Typography fontWeight="bold">Images:</Typography>
                    <Flex gap={"20px"}>
                      {refImg?.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={`ref-img=${index}`}
                          style={{ height: "100px", width: "150px" }}
                        />
                      ))}
                    </Flex>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        );
      })}
    </div>
  );
};

export default GroupImageViewer;
